(function () {
    'use strict';

    angular
        .module('app')
        .controller('QueueController', QueueController);

    QueueController.$inject = ['$scope', 'QueueService', '$interval', '$timeout'];

    function QueueController($scope, QueueService, $interval, $timeout) {
        var vm = this;
        vm.jobs = [];
        vm.queued = [];
        vm.running = [];
        vm.finished = [];
        vm.stats = { queued: 0, running: 0, finished: 0, failed: 0 };
        vm.activeJob = null;
        vm.loading = false;

        vm.loadData = function () {
            vm.loading = true;

            // Cargar estadísticas
            QueueService.getStats(function (data) {
                vm.stats = data;
            });

            // Cargar listado
            QueueService.getList(function (data) {
                vm.jobs = data;
                vm.groupJobs();
                vm.loading = false;
            });
        };

        vm.groupJobs = function () {
            vm.queued = [];
            vm.running = [];
            vm.finished = [];

            angular.forEach(vm.jobs, function (job) {
                if (job.status === 'PENDING') {
                    vm.queued.push(job);
                } else if (job.status === 'RUNNING') {
                    vm.running.push(job);
                } else {
                    vm.finished.push(job);
                }
            });
        };

        vm.refresh = function () {
            vm.loadData();
        };

        vm.newCommand = '';

        vm.addProcess = function () {
            vm.newCommand = '';
            var modalEl = document.getElementById('addProcessModal');
            if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                var modal = new bootstrap.Modal(modalEl);
                modal.show();
            } else if (typeof jQuery !== 'undefined' && jQuery.fn.modal) {
                jQuery(modalEl).modal('show');
            } else {
                console.error('Bootstrap modal not found');
            }
        };

        vm.submitCommand = function () {
            if (!vm.newCommand) return;
            vm.loading = true;
            QueueService.createCommand(vm.newCommand).then(function (jobId) {
                if (jobId) {
                    var modalEl = document.getElementById('addProcessModal');
                    if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                        var modal = bootstrap.Modal.getInstance(modalEl) || new bootstrap.Modal(modalEl);
                        modal.hide();
                    } else if (typeof jQuery !== 'undefined' && jQuery.fn.modal) {
                        jQuery(modalEl).modal('hide');
                    }
                    vm.loadData();
                    showToast('Proceso añadido', 'El comando ha sido añadido a la cola exitosamente.', 'success');
                } else {
                    showToast('Error', 'No se pudo añadir el comando a la cola.', 'danger');
                    vm.loading = false;
                }
            });
        };

        vm.viewLog = function (job) {
            vm.activeJob = job;
            var modalEl = document.getElementById('logModal');
            if (typeof bootstrap !== 'undefined' && bootstrap.Modal) {
                var modal = new bootstrap.Modal(modalEl);
                modal.show();
            } else if (typeof jQuery !== 'undefined' && jQuery.fn.modal) {
                jQuery(modalEl).modal('show');
            }
        };

        vm.retry = function (job) {
            showConfirmModal(
                'Relanzar Proceso',
                '¿Estás seguro de que quieres relanzar este trabajo?',
                'El comando se ejecutará nuevamente desde cero.',
                function () {
                    vm.loading = true;
                    QueueService.retry(job.job_id, function (data) {
                        if (data) {
                            showToast('Proceso relanzado', 'El trabajo ha sido puesto en cola nuevamente.', 'success');
                        } else {
                            showToast('Error', 'No se pudo relanzar el trabajo.', 'danger');
                        }
                        vm.loadData();
                    });
                },
                'Sí, relanzar',
                'btn-success',
                'rocket_launch'
            );
        };

        vm.cancelJob = function (job) {
            showConfirmModal(
                'Cancelar Trabajo',
                '¿Estás seguro de que quieres cancelar este trabajo?',
                'El proceso será terminado inmediatamente.',
                function () {
                    vm.loading = true;
                    QueueService.cancelJob(job.job_id).then(function (response) {
                        if (response.success) {
                            vm.loadData();
                            showToast('Trabajo cancelado', 'El trabajo ha sido cancelado exitosamente.', 'success');
                        } else {
                            showToast('Error', response.message || 'No se pudo cancelar el trabajo', 'danger');
                            vm.loading = false;
                        }
                    });
                },
                'Sí, cancelar trabajo',
                'btn-warning',
                'cancel'
            );
        };

        function showConfirmModal(title, message, detail, onConfirm, confirmText, confirmClass, confirmIcon) {
            var modalId = 'confirmModal-' + Date.now();
            var modalHtml =
                '<div class="modal fade" id="' + modalId + '" tabindex="-1" aria-hidden="true">' +
                '<div class="modal-dialog modal-dialog-centered">' +
                '<div class="modal-content border-0 shadow-lg">' +
                '<div class="modal-header ' + (confirmClass ? confirmClass + ' bg-opacity-10' : 'bg-warning bg-opacity-10') + ' border-0">' +
                '<h5 class="modal-title d-flex align-items-center">' +
                '<span class="material-symbols-outlined ' + (confirmClass ? confirmClass.replace('btn-', 'text-') : 'text-warning') + ' me-2">' + (confirmIcon || 'warning') + '</span>' +
                title +
                '</h5>' +
                '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                '</div>' +
                '<div class="modal-body">' +
                '<p class="mb-2"><strong>' + message + '</strong></p>' +
                '<p class="text-muted small mb-0">' + detail + '</p>' +
                '</div>' +
                '<div class="modal-footer border-0">' +
                '<button type="button" class="btn btn-secondary rounded-pill px-4" data-bs-dismiss="modal">Cancelar</button>' +
                '<button type="button" class="btn ' + (confirmClass || 'btn-warning') + ' rounded-pill px-4" id="confirmBtn-' + modalId + '">' +
                '<span class="material-symbols-outlined" style="font-size: 18px; vertical-align: middle;">' + (confirmIcon || 'check') + '</span> ' +
                (confirmText || 'Confirmar') +
                '</button>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';

            document.body.insertAdjacentHTML('beforeend', modalHtml);
            var modalElement = document.getElementById(modalId);
            var modal = new bootstrap.Modal(modalElement);

            document.getElementById('confirmBtn-' + modalId).addEventListener('click', function () {
                modal.hide();
                if (onConfirm) onConfirm();
            });

            modalElement.addEventListener('hidden.bs.modal', function () {
                modalElement.remove();
            });

            modal.show();
        }

        function showToast(title, message, type) {
            type = type || 'info';
            var toastId = 'toast-' + Date.now();
            var iconMap = {
                'success': 'check_circle',
                'danger': 'error',
                'warning': 'warning',
                'info': 'info'
            };
            var bgMap = {
                'success': 'bg-success',
                'danger': 'bg-danger',
                'warning': 'bg-warning',
                'info': 'bg-info'
            };
            
            // Contrast control
            var textColor = (type === 'success' || type === 'warning') ? 'text-dark' : 'text-white';
            var closeButtonClass = (type === 'success' || type === 'warning') ? '' : 'btn-close-white';

            var toastHtml = '<div id="' + toastId + '" class="toast align-items-center border-0 ' + bgMap[type] + ' ' + textColor + '" role="alert" aria-live="assertive" aria-atomic="true">' +
                '<div class="d-flex">' +
                '<div class="toast-body d-flex align-items-center">' +
                '<span class="material-symbols-outlined me-3" style="font-size: 24px;">' + iconMap[type] + '</span>' +
                '<div>' +
                '<strong class="d-block">' + title + '</strong>' +
                '<small class="opacity-75">' + message + '</small>' +
                '</div>' +
                '</div>' +
                '<button type="button" class="btn-close ' + closeButtonClass + ' me-2 m-auto" data-bs-dismiss="toast" aria-label="Close"></button>' +
                '</div>' +
                '</div>';

            var container = document.getElementById('toast-container');
            if (!container) {
                container = document.createElement('div');
                container.id = 'toast-container';
                container.className = 'toast-container position-fixed top-0 end-0 p-3';
                container.style.zIndex = '9999';
                document.body.appendChild(container);
            }

            container.insertAdjacentHTML('beforeend', toastHtml);
            var toastElement = document.getElementById(toastId);
            var toast = new bootstrap.Toast(toastElement, { delay: 4000 });
            toast.show();

            toastElement.addEventListener('hidden.bs.toast', function () {
                toastElement.remove();
            });
        }

        vm.getPercentage = function (value) {
            var total = (vm.stats.queued || 0) + (vm.stats.running || 0) + (vm.stats.finished || 0) + (vm.stats.failed || 0);
            if (total === 0) return 0;
            return (value / total) * 100;
        };

        vm.getElapsed = function (timestamp) {
            if (!timestamp) return '...';
            var seconds = Math.floor((Date.now() / 1000) - timestamp);
            if (seconds < 60) return seconds + 's';
            return Math.floor(seconds / 60) + 'm';
        };

        vm.getDuration = function (started_at, finished_at) {
            if (!started_at) return '0s';
            var end = finished_at ? finished_at : (Date.now() / 1000);
            var seconds = Math.floor(end - started_at);
            if (seconds < 0) seconds = 0;
            if (seconds < 60) return seconds + 's';
            return Math.floor(seconds / 60) + 'm ' + (seconds % 60) + 's';
        };

        // Auto-refresh cada 3 segundos para el modo Kanban
        var refreshInterval = $interval(function () {
            vm.loadData();
        }, 60000);

        $scope.$on('$destroy', function () {
            if (angular.isDefined(refreshInterval)) {
                $interval.cancel(refreshInterval);
            }
        });

        // Inicializar
        vm.loadData();
    }
})();
